import bemBlock from '@gik/core/utils/bemBlock';
import type { IBoxProps } from '@gik/ui/Box';
import { Box } from '@gik/ui/Box';
import classnames from 'classnames';
import React from 'react';
import type { Settings } from 'react-slick';
import Slider from 'react-slick';

export interface IBoxCarouselProps extends Settings, Omit<IBoxProps, 'draggable'> {
  children?: React.ReactNode;
  fadeSides?: boolean;
  contained?: boolean;
}

export function BoxCarousel({
  children,
  fadeSides,
  contained,
  className,
  variant,
  ...otherProps
}: IBoxCarouselProps): React.ReactElement {
  const bem = bemBlock('box-carousel');
  const blockClasses = classnames([
    bem(),
    { [`${bem()}--fade-sides`]: fadeSides },
    { [`${bem()}--contained`]: contained },
    className || '',
  ]);

  const settings: Settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 8000,
    ...otherProps,
  };

  return (
    <Box rounded="lg" className={blockClasses} variant={variant}>
      <main>
        <Slider {...settings}>{children}</Slider>
      </main>
      <div className={bem('mask')}></div>
    </Box>
  );
}
